import UntypedButtonTooltip from './ButtonTooltip';

export const ButtonTooltip = UntypedButtonTooltip as any;
